import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=64ba72b2&scoped=true"
import script from "./MediaPreview.vue?vue&type=script&lang=ts"
export * from "./MediaPreview.vue?vue&type=script&lang=ts"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=64ba72b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba72b2",
  null
  
)

export default component.exports